/****************************************************
 * Module Name:  mixPurchaseProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixPurchaseProxy {
  static GetAllPurchase = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/purchase",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllPurchaseByDate = (bucket, fromDate, toDate, callback) => {
    restAPICall(
      Constants.MANAGER_URL +
        `/mix/purchase/${bucket}/${fromDate}/${toDate}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllReportPurchaseByDate = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/purchase/query`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSinglePurchase = (purchaseId, callback) => {
    let params = {
      id: purchaseId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/purchase",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddPurchase = (purchase, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/purchase",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(purchase),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePurchase = (purchase, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/purchase",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(purchase),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
